/* eslint-disable no-param-reassign */
(() => {
  const whishListInjector = document.querySelector(".hidden-wishlist-btn .wkh-button");
  const wishListCounters = document.querySelectorAll(".js-wishlist-counter");

  const populateWishlistCounter = () => {
    if (!whishListInjector) {
      wishListCounters.forEach((counter) => {
        counter.classList.add("hidden");
        counter.setAttribute("aria-hidden", "true");
      });
      return;
    }

    wishListCounters.forEach((counter) => {
      const raw = whishListInjector.querySelector(".wkh-counter")?.innerText;
      const countNumber = Number.parseInt(raw || "0", 10) || 0;
      const isHeaderWishlistCounter = counter.parentElement.classList.contains("user-links__wishlist-link");

      if (countNumber <= 0) {
        counter.innerText = "";
        counter.classList.add("hidden");
        counter.setAttribute("aria-hidden", "true");
        return;
      }

      counter.classList.remove("hidden");
      counter.removeAttribute("aria-hidden");

      if (countNumber > 99 && isHeaderWishlistCounter) {
        counter.innerText = "99+";
        return;
      }
      counter.innerText = countNumber;
    });
  };

  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver(() => {
    populateWishlistCounter();
  });

  if (whishListInjector) {
    observer.observe(whishListInjector, observerOptions);
  }
  populateWishlistCounter();
})();
